import { useController, ApplicationView } from '@aha-app/mvc';
import Topbar from 'components/aha_editor_field_v2/plugins/LayoutComponents/Topbar';
import React, { type PropsWithChildren } from 'react';
import ContainerHeader from './ContainerHeader';
import WhiteboardContainerController from './WhiteboardContainerController';
import classes from './styles.module.css';

type TopControlsProps = {
  editor?: any;
  node?: any;
  editorV2?: boolean;
  showContainerHeader: boolean;
  collaborative: boolean;
};
export default ApplicationView(function TopControls({
  showContainerHeader,
  editor,
  node,
  editorV2,
  collaborative,
  children,
}: PropsWithChildren<TopControlsProps>) {
  const controller = useController(WhiteboardContainerController);
  const { displayMode } = controller.state;
  const fullScreen = displayMode.mode === 'fullscreen';

  const shouldShowEditButton =
    // We can just always hide the edit button if there is an editor (i.e. we're embedded)
    // because if the editor is editable, we show the <ContainerHeader> and it
    // renders it's own edit button.
    !(editor || editorV2) &&
    controller.isEditLocked() &&
    controller.state.allowUpdate &&
    controller.state.editable !== 'readOnly';

  const editButton = shouldShowEditButton ? (
    <aha-button
      kind='default'
      onClick={() => controller.actionEditLockedDocument()}
      aria-label='Edit whiteboard'
    >
      <i className='fa-regular fa-edit fa-fw' /> Edit
    </aha-button>
  ) : null;

  const topbar = (
    <Topbar
      onClose={() => {
        controller.router.navigate(controller.getDisplayModeUrl('inline'));
      }}
    >
      {children}
    </Topbar>
  );

  if (displayMode.mode === 'presentation') {
    return null;
  }

  if (!collaborative) {
    if (fullScreen) {
      return topbar;
    }

    return null;
  }

  if (fullScreen) {
    return (
      <>
        {topbar}
        {editButton ? (
          <div className={classes.whiteboardActions}>{editButton}</div>
        ) : null}
      </>
    );
  }

  if (showContainerHeader) {
    return <ContainerHeader editor={editor} node={node} />;
  }

  return editButton ? (
    <div className={classes.whiteboardActions}>{editButton}</div>
  ) : null;
});
